module.exports = __webpack_public_path__ + "img/turn@2x.783d1d75.png";